import { styled } from "../../Theme";
import { keyframes } from "styled-components";

const drawerContainerKeyFrame = keyframes`
 from {
    opacity: 0; 
  }

  to {
    opacity: 0.6;
  }
`;
export const DrawerContainer = styled.div`
  background-color: #000000;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  z-index: 4;
  animation: ${drawerContainerKeyFrame} 0.3s ease-in-out 0s;
  display: flex;
  flex-direction: column;
`;

const drawerKeyFrame = keyframes`
 from {
    bottom: -100%; 
  }

  to {
    bottom: 0%;
  }
`;

export const Drawer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  animation: ${drawerKeyFrame} 1s ease-in-out 0s;
`;

export const ButtonCancel = styled.div`
  align-self: flex-end;
  cursor: pointer;
  margin: 1em;
`;